import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, throwError } from "rxjs";
import { SnackbarService } from "../services/snackbar.service";

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbarService = inject(SnackbarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Lista de endpoints que manejan sus propios errores y no deben mostrar snackbar automático
      const endpointsConManejoPropio = [
        '/solicitud/movimientos/faplicacion',
        '/ConsultaFechaVacaciones'
      ];
      
      // Verificar si la URL del request coincide con alguno de los endpoints
      const manejadoPorComponente = endpointsConManejoPropio.some(endpoint => 
        req.url.includes(endpoint)
      );
      
      // Si el componente maneja el error, no mostrar snackbar
      if (manejadoPorComponente) {
        return throwError(() => error);
      }

      let errorMessage = "Ha ocurrido un error inesperado";

      if (error.status >= 400) {
        // Intentar obtener el mensaje del servidor (puede venir en 'errortxt' o 'error')
        const serverMessage = error.error?.errortxt || error?.error?.message || error.error?.error;
        
        switch (error.status) {
          case 400:
            errorMessage = serverMessage || "Solicitud incorrecta";
            break;
          case 401:
            errorMessage = serverMessage || "No autorizado. Por favor, inicie sesión nuevamente";
            break;
          case 403:
            errorMessage = serverMessage || "No tiene permisos para realizar esta acción";
            break;
          case 404:
            errorMessage = serverMessage || "Recurso no encontrado";
            break;
          case 409:
            errorMessage = serverMessage || "Conflicto en la operación";
            break;
          case 422:
            errorMessage = serverMessage || "Datos de entrada inválidos";
            break;
          case 500:
            errorMessage = serverMessage || "Error interno del servidor";
            break;
          case 502:
            errorMessage = serverMessage || "Servicio no disponible temporalmente";
            break;
          case 503:
            errorMessage = serverMessage || "Servicio no disponible";
            break;
          case 555:
            errorMessage = "Servicio no disponible";
            break
          default:
            errorMessage = `Error ${error.status}: ${error.statusText}`;
        }

        snackbarService.error(errorMessage);
      }

      return throwError(() => error);
    })
  );
};
